import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../shared/modals/modal.component';

const CannotBeginProcessingMessageModal = ({ hideModal, isVisible }) => (
  <Modal
    className="calculate-message-modal"
    dismissText="Close"
    closeAction={hideModal}
    dismissAction={hideModal}
    isVisible={isVisible}
  >
    <div>
      Unable to begin Batch Provision processing. Prior to processing a batch provision, the following must occur:
      <ul>
        <li>The period selected must be the current period.</li>
        <li>Sufficient privileges to Load Trial Balance and Calculate Provisions are required.</li>
      </ul>
    </div>
  </Modal>
);

CannotBeginProcessingMessageModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default CannotBeginProcessingMessageModal;
